import {
  Component,
  Inject,
  AfterViewInit,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { Base } from '../common/base';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserLoggedResponse, UserRolResponde } from '../../models/user';
import { AuthService } from '../../services/security/auth.service';
import { Router } from '@angular/router';
import { NotificacionGestion } from '../../models/gestion-referidos.model';
import { PoblacionService } from '../../services/poblacion/poblacion.service';
import { NotificacionReferidoService } from '../../services/notificacion-referido/notificacion-referido.service';
import { NotificacionGestionService } from '../../services/gestion-referidos/gestion-referidos.service';
import { NotificacionDetalleService } from '../../services/notificacion-detalle/notificacion-detalle.service';
import { forkJoin } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MY_DATE_FORMATS } from '../../utils/date-format';
import { MatSort } from '@angular/material/sort';
import { TrackData } from '../../models/app-track/track-data.model';
import { TrackingService } from '../../services/app-track/tracking.service';

@Component({
  selector: 'app-mis-referidos',
  templateUrl: './mis-referidos.component.html',
  styleUrls: ['./mis-referidos.component.css'],
  providers: [{ provide: 'MAT_DATE_FORMATS', useValue: MY_DATE_FORMATS }],
})
export class MisReferidosComponent
  extends Base
  implements AfterViewInit, OnInit
{
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort)
  set matSort(sort: MatSort) {
    if (sort) {
      this.dsReferidos.sort = sort;
    }
  }
  frmReferidos!: FormGroup;
  gestiones: Partial<NotificacionGestion>[] = [];

  tipo_id = [
    'BG – BEBÉ GESTANTE',
    'CC – CÉDULA DE CIUDADANÍA',
    'CE – CÉDULA DE EXTRANJERÍA',
    'CN - NACIDO VIVO',
    'PA – PASAPORTE',
    'PE – PERMISO ESPECIAL DE PERMANENCIA',
    'PT – PERMISO POR PROTECCIÓN TEMPORAL',
    'TI – TARJETA DE IDENTIDAD',
    'RC – REGISTRO CIVIL DE NACIMIENTO',
  ];

  referidos = ['SI', 'NO'];
  rolAsesor: string = '';

  haveResponde: boolean = false;
  haveDataToShow: boolean = false;
  dsReferidos: MatTableDataSource<any> = new MatTableDataSource<any>();
  attrData: string[] = [
    'fechaNotificacion',
    'fechaGestion',
    'tipoIdentificacion',
    'numeroIdentificacion',
    'nombreUsuario',
    'referidos',
    'telefono',
    'programa',
    'observaciones',
  ];

  namesColumns: string[] = [
    'Fecha de notificación',
    'Fecha de gestión',
    'Tipo de identificación usuario',
    'Número de identificación usuario',
    'Nombres y apellidos usuario',
    'Referidos',
    'Número de contacto usuario',
    'Programa',
    'Observaciones',
  ];
  generalMessage: string = '';

  logInfo: any;
  cedulaAsesor: any;
  loggedUser: any;
  nombre_Asesor: any;
  trackDataCarnet!: TrackData;

  loggedUserData: UserLoggedResponse = new UserLoggedResponse();

  constructor(
    private mainCmp: MaincontainerComponent,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private poblacionService: PoblacionService,
    private notificacionReferidoService: NotificacionReferidoService,
    private notificacionGestionService: NotificacionGestionService,
    private notificacionDetalleService: NotificacionDetalleService,
    private trackingService: TrackingService,
    public router: Router,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.haveResponde = false;
    this.haveDataToShow = false;
    this.frmReferidos = this.fb.group({
      tipo_identificacion: [''],
      identificacion: [''],
      estado_oportunidad: [''],
      fecha_creacion: [''],
      fecha_ultima_gestion: [''],
      referidos: [''],
    });
  }

  async ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle('CONSULTA GESTIÓN DE REFERIDOS');
    });
    this.loggedUser = await this.authService.getAuthInfo();
    console.log(this.loggedUser);
    sessionStorage.setItem('user', JSON.stringify(this.loggedUser));
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento en maincontainer', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    this.rolAsesor = this.logInfo?.roles[0].claveRol;
    this.dsReferidos.paginator = this.paginator;
    this.nombre_Asesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';

    console.log('userCC:', this.cedulaAsesor);
    console.log('role:', this.rolAsesor);

    this.trackDataCarnet = {
      module: 'Mis referidos',
      category: 'N/A',
      submodule: 'Consulta gestión de referidos',
      functionality: 'Consultar',
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombre_Asesor,
      identificadorInteraccion: 'REF_CONSULTA_REF_CONSULTAR'
    };
  }

  invertirNombreCompleto(nombre: string): string {
    if (!nombre) return '';

    const partes = nombre.trim().split(/\s+/);

    if (partes.length <= 2) {
      return nombre;
    }

    const nombres = partes.slice(2).join(' ');
    const apellidos = partes.slice(0, 2).join(' ');

    return `${nombres} ${apellidos}`;
  }

  calcularFechaDosMeses(fechaInicio: string): Date {
    const [year, month, day] = fechaInicio.split('-').map(Number);

    // Fecha LOCAL, sin UTC
    const fecha = new Date(year, month - 1, day);
    fecha.setMonth(fecha.getMonth() + 2);

    return fecha;
  }

  consultar(): void {
    this.spinner.show();

    if (!this.frmReferidos.valid) {
      this.generalMessage = 'Por favor completa los campos correctamente.';
      this.haveResponde = false;
      this.haveDataToShow = false;
      this.dsReferidos.data = [];
      this.spinner.hide();
      return;
    }

    const request = {
      identificationAsesor: this.cedulaAsesor,
      typeAsesor: this.rolAsesor,
      genero: '',
      parentesco: '',
      programa: '',
      edad: '',
    };

    forkJoin({
      poblacion: this.poblacionService.consultPoblacionActivos(request),
      notificacionesDetalle: this.notificacionDetalleService.mostrarActivos(),
      notificacionesReferido:
        this.notificacionReferidoService.getActiveNotifications(),
      gestiones: this.notificacionGestionService.mostrarTodos(),
    }).subscribe({
      next: ({
        poblacion,
        notificacionesDetalle,
        notificacionesReferido,
        gestiones,
      }) => {
        this.spinner.hide();

        if (!poblacion.data || poblacion.data.length === 0) {
          this.haveResponde = true;
          this.haveDataToShow = false;
          this.generalMessage = 'Sin información.';
          return;
        }

        // 1️⃣ Notificaciones SOLO del asesor logueado
        const notificacionesAsesor = notificacionesReferido.filter(
          (n: any) => Number(n.asesorId) === Number(this.cedulaAsesor),
        );

        // 2️⃣ IDs válidos de notificación
        const notificacionIds = new Set(
          notificacionesAsesor.map((n: any) => Number(n.idNotificacion)),
        );

        // 3️⃣ Detalles que sí pertenecen al asesor
        const detallesAsesor = notificacionesDetalle.filter(
          (d: any) =>
            d.idNotificacion !== null &&
            notificacionIds.has(Number(d.idNotificacion)),
        );

        // 4️⃣ Map de detalles
        const detalleMap = new Map<number, any>();
        detallesAsesor.forEach((d: any) =>
          detalleMap.set(Number(d.idDetalle), d),
        );

        // 5️⃣ Gestiones SOLO de esos detalles
        const gestionMap = new Map<number, any>();
        gestiones.forEach((g: any) => {
          if (detalleMap.has(Number(g.idDetalle))) {
            gestionMap.set(Number(g.idDetalle), g);
          }
        });

        // 6️⃣ Fecha de notificación
        const notiFechaMap = new Map<number, string>();
        notificacionesAsesor.forEach((n: any) =>
          notiFechaMap.set(Number(n.idNotificacion), n.fechaNotificacion),
        );

        // 7️⃣ Construcción del resultado FINAL
        let result: any[] = [];

        poblacion.data.forEach((usuario: any) => {
          const cedulaUsuario = Number(usuario.identificacion.split(' - ')[1]);

          const detalles = detallesAsesor.filter(
            (d: any) => Number(d.idUsuario) === cedulaUsuario,
          );

          detalles.forEach((detalle: any) => {
            const gestion = gestionMap.get(detalle.idDetalle);

            if (!gestion || !gestion.fechaGestion) {
              return;
            }

            const fechaNoti = this.calcularFechaDosMeses(usuario.FechaIniServ);
            const valorReferido = gestion ? gestion.referidos || 'SI' : '';

            if (valorReferido === 'NO' && gestion?.contador !== 2) return;

            const [tipo, numeroId] = usuario.identificacion.split(' - ');

            result.push({
              fechaNotificacion: fechaNoti ? this.formatDate(fechaNoti) : null,
              fechaGestion: gestion?.fechaGestion
                ? gestion.fechaGestion.split('T')[0]
                : null,
              tipoIdentificacion: tipo,
              numeroIdentificacion: numeroId,
              nombreUsuario: this.invertirNombreCompleto(usuario.nombre),
              referidos: valorReferido,
              telefono: usuario.Telefono,
              programa: usuario.Programa,
              observaciones: gestion?.observaciones || '',
            });
          });
        });

        // Aplicar filtros del formulario directamente aquí
        const {
          tipo_identificacion,
          identificacion,
          referidos,
          fecha_creacion,
          fecha_ultima_gestion,
        } = this.frmReferidos.value;

        result = result.filter((item: any) => {
          const tipoUserCode = (item['tipoIdentificacion'] || '')
            .slice(0, 2)
            .toUpperCase();
          const tipoFormCode = (tipo_identificacion || '')
            .slice(0, 2)
            .toUpperCase();

          const fechaNotiTable = item['fechaNotificacion'];
          const fechaGestTable = item['fechaGestion'];

          // Comparación de filtros
          const tipoMatch =
            !tipo_identificacion || tipoUserCode === tipoFormCode;
          const idMatch =
            !identificacion ||
            (item['numeroIdentificacion'] || '').includes(identificacion);

          const referidosMatch = !referidos || item['referidos'] === referidos;

          // Formatear fechas del formulario
          const fechaFormNoti = fecha_creacion
            ? this.formatDate(fecha_creacion)
            : null;
          const fechaFormGest = fecha_ultima_gestion
            ? this.formatDate(fecha_ultima_gestion)
            : null;

          let fechaNotiMatch = true;
          let fechaGestMatch = true;

          if (fecha_creacion) {
            fechaNotiMatch = fechaNotiTable === fechaFormNoti;
          }

          if (fecha_ultima_gestion) {
            fechaGestMatch = fechaGestTable === fechaFormGest;
          }

          return (
            tipoMatch &&
            idMatch &&
            referidosMatch &&
            fechaNotiMatch &&
            fechaGestMatch
          );
        });

        this.dsReferidos.data = result;
        this.dsReferidos.paginator = this.paginator;

        setTimeout(() => {
          this.dsReferidos.paginator = this.paginator;
        });
        this.haveResponde = true;
        this.haveDataToShow = result.length > 0;
        this.generalMessage = result.length === 0 ? 'Sin información.' : '';
      },
      error: (err) => {
        this.spinner.hide();
        this.haveResponde = true;
        this.haveDataToShow = false;
        this.generalMessage = 'Error en la consulta.';
        console.error(err);
      },
    });
  }

  formatDate(date: any): string {
    if (!date || date === '' || date === null || date === undefined) {
      return '';
    }

    if (typeof date === 'string' && date.includes('T')) {
      try {
        return date.split('T')[0];
      } catch {
        return '';
      }
    }

    if (typeof date === 'string' && date.includes('/')) {
      return date.replace(/\//g, '-');
    }

    if (date instanceof Date) {
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${date.getFullYear()}-${month}-${day}`;
    }

    if (typeof date === 'string' && date.includes('-') && !date.includes('T')) {
      return date;
    }

    return '';
  }

  clear(): void {
    this.frmReferidos.reset();
    this.generalMessage = '';
    this.haveResponde = false;
    this.haveDataToShow = false;
    this.dsReferidos.data = [];
  }

  deleteSpaceAsesor(identification: string): string {
    const parts = identification.split('.');
    return parts.length > 1 ? parts[1].trim() : '';
  }

  get getControl() {
    return this.frmReferidos.controls;
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}
